import {RoundInfo} from '@gongxigames/framework/slot/types';

export enum CancelStartSpinReason {
    INSUFFICIENT_FUNDS = 'insufficientFunds'
}

export type CancelStartSpinData = {
    reason: CancelStartSpinReason,
    balanceRefreshCallback?: () => void
};

export type FlowEvents = {
    'General.Flow.PAID_ROUND_ENDED': RoundInfo;
    'General.Flow.WAIT_EVENT_BEFORE_RESTORE_GAME': string | symbol;
    'General.Flow.WAITING_OF_RESTORE_GAME': void;
    'General.Flow.cancelStartSpin': CancelStartSpinData;
};
